import { IdealFirstDateOptionsType } from './types';

export const IDEAL_FIRST_DATE_OPTIONS: IdealFirstDateOptionsType = [
  { id: 'rooftop_bar', title: 'Rooftop bar', icon: '🥂' },
  { id: 'beach_night', title: 'Beach at night', icon: '🌴' },
  { id: 'indie_movie', title: 'Indie movie + snacks', icon: '🎬' },
  { id: 'secret_speakeasy', title: 'Secret speakeasy', icon: '🔒' },
  { id: 'home_candles', title: 'Home, candles, no clothes', icon: '🕯️' },
];
